export const parseJwtExpiryMs = (token?: string | null): number | null => {
  if (!token) return null;

  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;

    const payloadBase64Url = parts[1];
    const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = payloadBase64.length % 4;
    const paddedBase64 = payloadBase64 + (padLength ? '='.repeat(4 - padLength) : '');
    const payloadText = atob(paddedBase64);
    const payload = JSON.parse(payloadText) as { exp?: number };

    if (!payload?.exp || typeof payload.exp !== 'number') return null;
    return payload.exp * 1000;
  } catch (error) {
    return null;
  }
};

